
import "@sparta.login.shared-components/ah-secure-signin-shared-component/dist/styles.css"
import "@sparta.authglobal.utilities/ah-shared-component-config-compiler-utility/dist/styles.css"
import "@sparta.global.utilities/sparta-squeezebox-utility/dist/styles.css"
import "@sparta.login.shared-components/ah-passkey-signin-shared-component/dist/styles.css"
import "@sparta.global.utilities/sparta-carousel-utility/dist/styles.css"
import "@sparta.global.utilities/sparta-sticky-utility/dist/styles.css"
import "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/styles.css"
import "@sparta.homepage.modules/open-an-account-module/dist/styles.css"
import "@sparta.homepage.modules/highlight-lowlight-module/dist/styles.css"
import "@sparta.homepage.modules/bmh-module/dist/styles.css"
import "@sparta.homepage.modules/news-information-module/dist/styles.css"
import "@sparta.global.modules/connect-with-us-module/dist/styles.css"
import "@sparta.global-tenants.modules/gt-unauth-main-module/dist/styles.css"
import "@sparta.global-tenants.modules/gt-footer-unauth-placeholder-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import homepageBootstrapUtility from "@sparta.homepage.utilities/homepage-bootstrap-utility/dist/es6.js"
import syncAlloyUtility from "@sparta.global-vtim.utilities/sync-alloy-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import alloyBootstrapUtility from "@sparta.homepage.utilities/alloy-bootstrap-utility/dist/es6.js"

import "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/es6.js"
import "@sparta.homepage.modules/open-an-account-module/dist/es6.js"
import "@sparta.homepage.modules/highlight-lowlight-module/dist/es6.js"
import "@sparta.homepage.modules/bmh-module/dist/es6.js"
import "@sparta.homepage.modules/news-information-module/dist/es6.js"
import "@sparta.global.modules/connect-with-us-module/dist/es6.js"
import "@sparta.sales.modules/ap-module/dist/es6.js"
import "@sparta.global-tenants.modules/gt-unauth-main-module/dist/es6.js"
import "@sparta.global-tenants.modules/gt-footer-unauth-placeholder-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.login.shared-components/ah-secure-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-secure-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-secure-signin-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-passkey-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-passkey-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-passkey-signin-shared-component/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es6.js" )}
    }
  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init();
homepageBootstrapUtility.init();
alloyBootstrapUtility.init();
  console.log('after - execute boot functions')
})();
